import React from 'react';
import { Box, Container, Grid, Typography, Card, CardContent, Stepper, Step, StepLabel } from '@mui/material';
import {
  Create,
  Search,
  Description,
  Flight,
  School,
  Assignment,
  Payment,
  LocalHospital,
  CheckCircle,
} from '@mui/icons-material';

const steps = [
  {
    icon: <Create sx={{ fontSize: 40 }} />,
    title: 'Registration',
    description: 'Fill out our simple registration form with your academic details and preferences',
    color: '#1565C0',
  },
  {
    icon: <Search sx={{ fontSize: 40 }} />,
    title: 'College Selection',
    description: 'Our experts help you choose the best college based on your budget and preferences',
    color: '#E65100',
  },
  {
    icon: <Description sx={{ fontSize: 40 }} />,
    title: 'Documentation',
    description: 'We assist in preparing and verifying all required documents for admission',
    color: '#2E7D32',
  },
  {
    icon: <Assignment sx={{ fontSize: 40 }} />,
    title: 'Application',
    description: 'Submit your application to the selected colleges with our guidance',
    color: '#6A1B9A',
  },
  {
    icon: <Payment sx={{ fontSize: 40 }} />,
    title: 'Fee Payment',
    description: 'Secure payment of admission and tuition fees with proper receipts',
    color: '#C62828',
  },
  {
    icon: <Flight sx={{ fontSize: 40 }} />,
    title: 'Visa Processing',
    description: 'Complete visa assistance for abroad studies including documentation',
    color: '#00838F',
  },
  {
    icon: <LocalHospital sx={{ fontSize: 40 }} />,
    title: 'Medical Checkup',
    description: 'Arrange medical fitness certificates required for admission',
    color: '#EF6C00',
  },
  {
    icon: <School sx={{ fontSize: 40 }} />,
    title: 'Travel & Joining',
    description: 'Assistance with travel arrangements and joining formalities at college',
    color: '#283593',
  },
  {
    icon: <CheckCircle sx={{ fontSize: 40 }} />,
    title: 'Post Admission Support',
    description: 'Continued support throughout your medical education journey',
    color: '#558B2F',
  },
];

const AdmissionProcess = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="xl">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 2, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Admission{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            Process
          </Box>
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          Simple 9-step process to secure your medical seat
        </Typography>

        <Grid container spacing={3}>
          {steps.map((step, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  position: 'relative',
                  overflow: 'visible',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                  },
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: -20,
                    left: 30,
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 700,
                    fontSize: '1.2rem',
                  }}
                >
                  {index + 1}
                </Box>
                <CardContent sx={{ pt: 5, pb: 3, px: 3 }}>
                  <Box sx={{ color: step.color, mb: 2 }}>{step.icon}</Box>
                  <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                    {step.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                    {step.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AdmissionProcess;